// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2iQDF","tableRow":"styles_tableRow__36Uuy","sorted":"styles_sorted__m19Nx"};